<template>
  <div class="cat-state" :style="`${align === 'round' ? 'margin-left: 16px;' : ''}`">
    <span :class="`state-${type}`"></span>
    <span :style="textStyle">{{ text }}</span>
  </div>
</template>
<script lang="ts" setup>
type IRoundType = 'circle' | 'dotted'; // 空心圆点 | 实心圆点
type IAlignType = 'round' | 'text'; // 圆点左对齐 | 文本左对齐
interface Props {
  text?: string;
  color?: string;
  type?: IRoundType;
  fontStyle?: {};
  align?: IAlignType | number;
}
const props = withDefaults(defineProps<Props>(), {
  text: '已通过',
  color: '#3dca97',
  type: 'dotted',
  align: 'round',
});
const { text, color, type, fontStyle, align } = toRefs(props);
const textStyle = computed(() => ({
  color: color.value,
  ...fontStyle?.value,
}));
</script>
<style lang="scss" scoped>
.cat-state {
  .state-dotted {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: calc(50% - 4px);
      translate: -16px;
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: v-bind(color);
    }
  }

  .state-circle {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: calc(50% - 4px);
      translate: -16px;
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 2px solid v-bind(color);
      z-index: 99;
    }
  }
}
</style>
